<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon> 
      <slot>Exportar</slot>
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Productos</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Archivo CSV preparado</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-box-open</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Datos procesados!</div>
          <div class="caption grey--text px-4 mb-6">El inventario de productos ha sido exportado exitosamente.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {fetchProducts} from '@/api/products'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'

export default {
  name: "ExportProducts",
  props: ['family', 'line', 'disabled', 'for_update'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      items: [],
      dataReady: false,
      csvTitle: `export_productos_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  computed: {
    labels() {
      if (this.for_update) {
        return { 
          sku: { title: 'sku' },
          name: { title: 'name' },
          family: { title: 'family' },
          line: { title: 'line' },
          width: { title: 'width' },
          height: { title: 'height' },
          price: { title: 'price' },
          sell_unit_m2: { title: 'sell_unit_m2' },
          status: { title: 'status' }
        }
      } else {
        return {
          sku: { title: 'Código' },
          name: { title: 'Descripción' },
          family_name: { title: 'Familia' },
          line_name: { title: 'Línea' },
          width: { title: 'Ancho' },
          height: { title: 'Alto' },
          price: { title: 'Precio' },
          sell_unit_m2: { title: 'Venta Mts2' },
        }
      }
    },
  },
  methods: {
    async fetch() {
      this.loading = true
      const query = `ordering=-sku&family=${this.family}&line=${this.line}`
      await fetchProducts(query)
        .then((data) => {
          this.items = data.results
          data.results.forEach(p => {
            p.width = parseFloat(p.width).toFixed(2)
            p.height = parseFloat(p.height).toFixed(2)
            p.price = parseFloat(p.price).toFixed(2)
          });
          this.dataReady = true
        })
        .catch((err) => {
          notifications.showError('Error cargando productos ' + err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSuccess(val) {
      notifications.showSuccess('Productos Exportados')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Productos')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>